module.exports = __webpack_public_path__ + "static/media/bg-8.245e9c9d.jpg";